export default {
  methods: {
    async waitForUser(arg) {
      await this.$store.dispatch('user/getMe')
      return arg
    },
  }
}
